import { Button } from '@ui/kit';
import { useOpgavekompleksetComponent } from '../../../state/context.data.js';
import { useOpgavekompleksetEntry } from '../../../state/hook.entry.js';
import { jsx, Fragment, jsxs } from 'react/jsx-runtime';

function ValidateButton(props) {
  const component = useOpgavekompleksetComponent();
  const canValidate = useOpgavekompleksetEntry({
    select: entry => Object.keys(entry?.data.tasks[props.currentTaskId]?.details ?? {}).length > 0
  });
  const attempts = useOpgavekompleksetEntry({
    select: entry => entry?.data.tasks[props.currentTaskId]?.state.attempts ?? 0
  }) ?? 0;
  const maxAttempts = component.data.settings.allowedAttempts;
  const remainingAttempts = maxAttempts - attempts;
  return /*#__PURE__*/jsx(Button, {
    theme: "primary",
    onClick: props.onClick,
    disabled: !canValidate,
    icon: maxAttempts > 1 ? {
      position: "after",
      content: /*#__PURE__*/jsx(Fragment, {
        children: remainingAttempts
      }),
      theme: "background"
    } : undefined,
    tooltip: {
      body: canValidate ? /*#__PURE__*/jsxs(Fragment, {
        children: ["Du har ", remainingAttempts, " fors\xF8g tilbage"]
      }) : "Udfyld opgaven, for at tjekke svaret",
      placement: "top",
      ariaType: "description"
    },
    children: "Tjek svar"
  });
}

export { ValidateButton };
//# sourceMappingURL=button.validate.js.map
